import { Injectable } from '@angular/core';
import { ErrorCodesService } from '../interfaces/error-codes.service';

@Injectable({
  providedIn: 'root',
})
export class MockErrorCodesService extends ErrorCodesService {
  constructor() {
    super();
  }
  getError(validation: string, fieldName: string): string {
    return validation + fieldName;
  }
}
